import { getDocumentStore } from '../components/DocumentEditor/useDocumentStore';
import { getCreateFileStore } from '../components/CreateFile/useCreateFileStore';
import { getEmailStore } from '../components/Email/useEmailStore';
import { getCodeStore } from '../components/Code/useCodeStore';
import { getAPIResReqStore } from '../components/APIRequestAndResponse/useAPIResReqStore';
import { getSlackStore } from '../components/Slack/useSlackStore';
import { getQueryDatabaseStore } from '../components/QueryDatabase/useQueryDatabaseStore';
import { getUpdateDatabaseRecordStore } from '../components/UpdateDatabaseRecord/useUpdateDatabaseRecordStore';
import { getCreateDatabaseRecordStore } from '../components/CreateDatabaseRecord/useCreateDatabaseRecordStore';
import { getConditionalLogicStore } from '../components/ConditionalLogic/useConditionalLogicStore';
import { getConditionalWorkflowStore } from '../components/ConditionalWorkflow/useConditionalWorkflowStore';
import { getConditionalWorkflowPathStore } from '../components/ConditionalWorkflowPath/useConditionalWorkflowPathStore';
import { getLoopThroughListStore } from '../components/LoopThroughList/useLoopThroughListStore';
import { getTimeDelayStore } from '../components/TimeDelay/useTimeDelayStore';
import { getTriggerAZapStore } from '../components/TriggerAZap/useTriggerAZapStore';
import { getTriggerFromZapierStore } from '../components/TriggerFromZapier/useTriggerFromZapierStore';
import { getTriggerFromExternalStore } from '../components/TriggerFromExternal/useTriggerFromExternalStore';
import { getTriggerAnotherWorkflowStore } from '../components/TriggerAnotherWorkflow/useTriggerAnotherWorkflowStore';
import { getTriggerFromAWorkflowStore } from '../components/TriggerFromAWorkflow/useTriggerFromAWorkflowStore';
import { getTriggerOnDatabaseUpdateStore } from '../components/TriggerOnDatabaseUpdate/useTriggerOnDatabaseUpdateStore';
import { getTriggerFromApiPollingStore } from '../components/TriggerFromApiPolling/useTriggerFromApiPollingStore';
import { getEmailTriggerStore } from '../components/EmailTrigger/useEmailTriggerStore';
import { getWebhookImportStore } from '../components/WebhookImport/useWebhookImportStore';
import { getWebhookTriggerStore } from '../components/WebhookTrigger/useWebhookTriggerStore';
import { getSessionVariableStore } from '../components/SessionVariable/useSessionVariableStore';
import { getCalculatorStore } from '../components/Calculator/useCalculatorStore';
import { getMergeWorkflowStore } from '../components/MergeWorkflow/useMergeWorkflowStore';
import { getConvergeThreadsStore } from '../components/ConvergeThreads/useConvergeThreadsStore';
import { getBulkAssessmentStore } from '../components/BulkAssessment/useBulkAssessmentStore';
import { getParseJSONStore } from '../components/ParseJSON/useParseJSONStore';
import { getBranchPathsStore } from '../components/BranchPaths/useBranchPathsStore';
import { getTransformStore } from '../components/ListTransform/useTransformStore';
import { getAIAssistantTemplateStore } from '../components/AIAssistant/useAIAssistantTemplateStore';
import { getAIAgentStore } from '../components/AIAgent/useAIAgentStore';
import { getAwaitExternalEventStore } from '../components/AwaitExternalEvent/useAwaitExternalEventStore';
import { getApiExportStore } from '../components/ApiExport/useApiExportStore';
import { getHttpRequestStore } from '../components/HttpRequest/useHttpRequestStore';
import { getScheduleStartStore } from '../components/ScheduleStart/useScheduleStartStore';
import { getFormBuilderStore } from '../components/FormBuilder/useFormBuilderStore';
import { getSequentialFormStore } from '../components/SequentialForm/useSequentialFormStore';
import { getDynamicFormStore } from '../components/DynamicFormBuilder/useDynamicFormStore';
import { getDynamicReviewTaskStore } from '../components/DynamicReviewTask/useDynamicReviewTaskStore';
import { getFormStepStore } from '../components/FormStep/useFormStepStore';
import { getGatewayStore } from '../components/Gateway/useGatewayStore';
import { getQueryTableV2Store } from '../components/QueryTableV2/useQueryTableV2Store';
import { getCreateRowV2Store } from '../components/CreateRowV2/useCreateRowV2Store';
import { getUpdateRowV2Store } from '../components/UpdateRowV2/useUpdateRowV2Store';
import { getTriggerTableV2Store } from '../components/TriggerTableV2/useTriggerTableV2Store';
import { getCustomFunctionInstanceStore } from '../components/CustomFunctions/useCustomFunctionInstanceStore';

import { protectLoadedStore } from './storeWriteGuard';

// Maps component type to { getStore, setter }
// All stores now use the standard setComponentData interface.
export const storeMap = {
  document_editor:          { getStore: getDocumentStore,              setter: 'setComponentData' },
  create_file:              { getStore: getCreateFileStore,            setter: 'setComponentData' },
  email:                    { getStore: getEmailStore,                 setter: 'setComponentData' },
  code:                     { getStore: getCodeStore,                  setter: 'setComponentData' },
  advanced_code:            { getStore: getCodeStore,                  setter: 'setComponentData' },
  form:                     { getStore: getFormBuilderStore,            setter: null },
  sequential_form:          { getStore: getSequentialFormStore,         setter: null },
  form_section:             { getStore: getSequentialFormStore,         setter: null },
  api_request_and_response: { getStore: getAPIResReqStore,             setter: 'setComponentData' },
  http_request:             { getStore: getHttpRequestStore,           setter: 'setComponentData' },
  slack:                    { getStore: getSlackStore,                 setter: 'setComponentData' },
  workflow_data:            { getStore: getSlackStore,                 setter: 'setComponentData' },
  query_database_record:    { getStore: getQueryDatabaseStore,         setter: 'setComponentData' },
  data_bank:                { getStore: getQueryDatabaseStore,         setter: 'setComponentData' },
  update_database_record:   { getStore: getUpdateDatabaseRecordStore,  setter: 'setComponentData' },
  create_database_record:   { getStore: getCreateDatabaseRecordStore,  setter: 'setComponentData' },
  conditional_logic:        { getStore: getConditionalLogicStore,      setter: 'setComponentData' },
  conditional_workflow:     { getStore: getConditionalWorkflowStore,   setter: 'setComponentData' },
  conditional_workflow_path:{ getStore: getConditionalWorkflowPathStore, setter: 'setComponentData' },
  loop_through_list:        { getStore: getLoopThroughListStore,       setter: 'setComponentData' },
  time_delay:               { getStore: getTimeDelayStore,             setter: 'setComponentData' },
  trigger_a_zap:            { getStore: getTriggerAZapStore,           setter: 'setComponentData' },
  trigger_from_zapier:      { getStore: getTriggerFromZapierStore,     setter: 'setComponentData' },
  trigger_from_external_app:{ getStore: getTriggerFromExternalStore,   setter: 'setComponentData' },
  trigger_another_workflow: { getStore: getTriggerAnotherWorkflowStore,setter: 'setComponentData' },
  trigger_from_a_workflow:  { getStore: getTriggerFromAWorkflowStore,  setter: 'setComponentData' },
  trigger_on_database_update:{ getStore: getTriggerOnDatabaseUpdateStore, setter: 'setComponentData' },
  trigger_from_api_polling: { getStore: getTriggerFromApiPollingStore,  setter: 'setComponentData' },
  trigger_via_email:        { getStore: getEmailTriggerStore,          setter: 'setComponentData' },
  webhook:                  { getStore: getWebhookImportStore,         setter: 'setComponentData' },
  webhook_trigger:          { getStore: getWebhookTriggerStore,        setter: 'setComponentData' },
  session_variables:        { getStore: getSessionVariableStore,       setter: 'setComponentData' },
  calculator:               { getStore: getCalculatorStore,            setter: 'setComponentData' },
  merge_workflow:            { getStore: getMergeWorkflowStore,         setter: 'setComponentData' },
  converge_threads:         { getStore: getConvergeThreadsStore,       setter: 'setComponentData' },
  bulk_assessment:          { getStore: getBulkAssessmentStore,        setter: 'setComponentData' },
  parse_json:               { getStore: getParseJSONStore,             setter: 'setComponentData' },
  branch_paths:             { getStore: getBranchPathsStore,           setter: 'setComponentData' },
  list_transform:           { getStore: getTransformStore,             setter: 'setComponentData' },
  ai_assistant:             { getStore: getAIAssistantTemplateStore,   setter: 'setComponentData' },
  ai_agent:                 { getStore: getAIAgentStore,               setter: 'setComponentData' },
  await_external_event:     { getStore: getAwaitExternalEventStore,    setter: 'setComponentData' },
  api_export:               { getStore: getApiExportStore,             setter: 'setComponentData' },
  schedule_start:           { getStore: getScheduleStartStore,         setter: 'setComponentData' },
  dynamic_form:             { getStore: getDynamicFormStore,            setter: 'setComponentData' },
  dynamic_review_task:      { getStore: getDynamicReviewTaskStore,     setter: 'setComponentData' },
  form_step:                { getStore: getFormStepStore,               setter: 'setComponentData' },
  gateway:                  { getStore: getGatewayStore,              setter: 'setComponentData' },
  query_table_v2:           { getStore: getQueryTableV2Store,        setter: 'setComponentData' },
  create_row_v2:            { getStore: getCreateRowV2Store,         setter: 'setComponentData' },
  update_row_v2:            { getStore: getUpdateRowV2Store,         setter: 'setComponentData' },
  trigger_table_v2:         { getStore: getTriggerTableV2Store,      setter: 'setComponentData' },
  custom_function:          { getStore: getCustomFunctionInstanceStore, setter: 'setComponentData' },
};

/**
 * Prefills all keyed component stores from the rawComponentData returned
 * by the GraphQL canvas query. This eliminates the REST fetch on pane open.
 *
 * @param {Array} components - components array from the GraphQL response
 * @param {number} version - current workflow version
 */
export function prefillComponentStores(components, version) {
  if (!components) return;

  for (const comp of components) {
    const config = storeMap[comp.type];
    if (!config || !config.setter) continue;
    if (!comp.rawComponentData) continue;

    try {
      const store = config.getStore(comp.componentId);
      const state = store.getState();

      if (state.loaded) continue;

      const componentObj = { componentId: comp.componentId, type: comp.type, description: comp.description, componentData: comp.rawComponentData, version };

      state[config.setter](componentObj);

      store.setState({
        loaded: true,
        name: comp.componentData?.name || comp.rawComponentData?.name || '',
        componentDescription: comp.description || '',
      });

      protectLoadedStore(store);
    } catch (e) {
      console.error(`[prefill] Failed for ${comp.type}/${comp.componentId}:`, e);
    }
  }
}
